var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"S8jfhAD"},[_c('p',[_vm._v("All rights reserved. Copyright Boma of Africa © 2023")])])}]

export { render, staticRenderFns }